var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Seite nicht gefunden")]),_vm._v(" Zurück zur "),_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")]),_vm._v("-Seite oder zum "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")]),_vm._v(". ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }